import { Component, OnInit, OnDestroy, DoCheck } from '@angular/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { StudentModel } from '../../pathways-ui/models/student.model';
import { BackofficeService } from '../../pathways-ui/services/backoffice.service';
import { ReferenceOption } from '../../pathways-ui/models/reference.option';
import { ConsentModel } from '../../pathways-ui/models/consent.model';
import { Views } from '../../pathways-ui/models/backoffice-views.consts';
import { StudentProfile } from '../../pathways-ui/models/student-profile.model';
import { ReferenceTableService } from '../../pathways-ui/services/reference-table.service';
import { environment } from 'src/environments/environment';
import { FeatureService } from 'src/app/services/feature.service';
import { ChatService } from 'src/app/services/chat.service';

@Component({
    selector: 'side-nav-parent-view',
    templateUrl: './side-nav-parent-view.component.html',
    styleUrls: ['./side-nav-parent-view.component.css'],
})
export class SideNavParentViewComponent implements OnInit, OnDestroy, DoCheck {
    private destroyed$ = new Subject();
    
    constructor(
        private _boService: BackofficeService,
        public referenceTables: ReferenceTableService,
        private featureService: FeatureService,
        private chatService: ChatService
    ) {}
    data: StudentModel[] = [];
    Views = Views;
    currentView: string = '';
    isQcLocation: boolean = false;
    subscriptions: Subscription[] = [];
    gradeOptionsRef: ReferenceOption[] = [];
    isUploading: boolean = false;
    studentProfile: StudentProfile;

    archivedData: StudentModel[] = [];
    syncedData: StudentModel[] = [];
    consentDocumentData: ConsentModel[] = [];

    hasNewMessage: boolean = false;
    unreadStatus: boolean = false;

    isFeatureEnabled(featureName: string): boolean {
        return this.featureService.isFeatureEnabled(featureName);
    }

    ngOnInit() {
        this.setCurrentView(Views.Inbox);

        // this.chatService.checkForNewMessage().pipe(
        //     takeUntil(this.destroyed$))
        //     .subscribe((result) => {
        //     // console.log("New Messages: ", result);
        //     this.hasNewMessage = result;
        //     this.unreadStatus = this.chatService.getUnreadMessageStatus();
        //     // console.log("message status: ", this.unreadStatus);
        // })
    }

    ngDoCheck(): void {
        const url = new URL(window.location.href);

        if (url.pathname.toLowerCase().includes(Views.Inbox)) {
            this.setCurrentView(Views.Inbox);
        }

        if (url.pathname.toLowerCase().includes(Views.Profile)) {
            this.setCurrentView(Views.Profile);
        }

        if (url.pathname.toLowerCase().includes(Views.AllSettings)) {
            this.setCurrentView(Views.AllSettings);
        }

        if (url.pathname.toLowerCase().includes(Views.Chat)) {
            this.setCurrentView(Views.Chat);
        }
        if (url.pathname.toLowerCase().includes(Views.Feed)) {
            this.setCurrentView(Views.Feed);
        }
        if (url.pathname.toLowerCase().includes(Views.Goals)) {
            this.setCurrentView(Views.Goals);
        }

        if (url.pathname.toLowerCase().includes(Views.ReRegistrationSettings)) {
            this.setCurrentView(Views.ReRegistrationSettings);
        }
        //Temp view settings
        if (url.pathname.toLowerCase().includes("youthworker")) {
            this.setCurrentView("youthworker");
        }

    }

    ngOnDestroy(): void {
      this.subscriptions.forEach((subscription) =>
          subscription.unsubscribe()
      );
      this.destroyed$.next(true);
      this.destroyed$.complete();
    }

    setCurrentView(newView: string) {
        this.currentView = newView;
    }
}
